import { render } from "./CommissionSearchCriteria.vue?vue&type=template&id=1aa0a2fe"
import script from "./CommissionSearchCriteria.vue?vue&type=script&lang=js"
export * from "./CommissionSearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__